"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var CallProgress = function CallProgress(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.34,13.42h0c-.26.26-.48.52-.76.76a1.19,1.19,0,0,1-.82.4h-.15a3.52,3.52,0,0,1-1.39-.28,8.88,8.88,0,0,1-2.71-1.64,8.08,8.08,0,0,1-.6-.57,8.08,8.08,0,0,1-.57-.6A8.88,8.88,0,0,1,5.7,8.78a3.52,3.52,0,0,1-.28-1.39h0V7.24h0a1.19,1.19,0,0,1,.4-.82c.24-.28.5-.5.76-.76h0a.72.72,0,0,1,1.07,0l.62.62.57.59h0a.65.65,0,0,1,.26.53h0A.69.69,0,0,1,8.84,8a7.21,7.21,0,0,0-.7.79h0a.15.15,0,0,0-.06.11h0V9a4.51,4.51,0,0,0,.68,1v0q.27.33.57.63t.63.57h0a4.51,4.51,0,0,0,1,.68h.16a.15.15,0,0,0,.11-.06h0a7.21,7.21,0,0,0,.79-.7.69.69,0,0,1,.54-.26h0a.65.65,0,0,1,.53.26h0l.59.57.62.62a.72.72,0,0,1,0,1.07Z"
  }));
};
var _default = exports["default"] = CallProgress;